import { Box, Paper } from "@mui/material";
import { useContext, useEffect } from "react";
import { Outlet } from "react-router";
import MainContext from "../../context/mainContext";
import WorkflowContextProvider from "./context/WorkflowContextProvider";
import Steps from "./Steps";
import styles from "./Workflow.module.scss";
import WorkflowTitle from "./WorkflowTitle";

const Workflow: React.FC = () => {
  const { setBanner } = useContext(MainContext);

  useEffect(() => {
    setBanner("banner-river.png");
  });

  return (
    <WorkflowContextProvider>
      <Box className={styles.workflowMain}>
        <WorkflowTitle />
        <Paper className={styles.workflowContent}>
          <Steps />
          <Box className={styles.stepBox}>
            <Outlet />
          </Box>
        </Paper>
      </Box>
    </WorkflowContextProvider>
  );
};

export default Workflow;
